export default __webpack_public_path__ + "static/media/Looking into the Future 2017 -- Pastel and Ink on Paper with Paper Collage -- 18in x 22in.1bc047b8.jpg";